import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { Options, Option } from './package-size-and-weight.component.styles'
import { Body } from 'ggx-componentlibrary/design/typography/typography.styles'
import Size1Image from './assets/size-1.svg'
import Size2Image from './assets/size-2.svg'
import Size3Image from './assets/size-3.svg'
import Size4Image from './assets/size-4.svg'
import Size5Image from './assets/size-5.svg'
import Size6Image from './assets/size-6.svg'

const PackageSizeRadio = ({ size_option, length, width, height }) => {
  const [t] = useTranslation()
  const selectOption = value => {
    size_option.input.onChange(value)
    const packageSize = [
      ['20', '20', '10'],
      ['30', '30', '30'],
      ['40', '40', '40'],
      ['50', '50', '50'],
      ['60', '60', '60'],
      ['', '', ''],
    ][value - 1]
    length.input.onChange(packageSize[0])
    width.input.onChange(packageSize[1])
    height.input.onChange(packageSize[2])
  }
  useEffect(() => {
    selectOption(1)
  }, [])
  return (
    <Options>
      <Option
        selected={size_option.input.value === 1}
        onClick={() => selectOption(1)}
      >
        <Size1Image />
        <Body typographyStyles="mb-none">{t('package_size__20')}</Body>
      </Option>
      <Option
        selected={size_option.input.value === 2}
        onClick={() => selectOption(2)}
      >
        <Size2Image />
        <Body typographyStyles="mb-none">{t('package_size__30')}</Body>
      </Option>
      <Option
        selected={size_option.input.value === 3}
        onClick={() => selectOption(3)}
      >
        <Size3Image />
        <Body typographyStyles="mb-none">{t('package_size__40')}</Body>
      </Option>
      <Option
        selected={size_option.input.value === 4}
        onClick={() => selectOption(4)}
      >
        <Size4Image />
        <Body typographyStyles="mb-none">{t('package_size__50')}</Body>
      </Option>
      <Option
        selected={size_option.input.value === 5}
        onClick={() => selectOption(5)}
      >
        <Size5Image />
        <Body typographyStyles="mb-none">{t('package_size__60')}</Body>
      </Option>
      <Option
        selected={size_option.input.value === 6}
        onClick={() => selectOption(6)}
      >
        <Size6Image />
        <Body typographyStyles="mb-none">{t('package_size__custom')}</Body>
      </Option>
    </Options>
  )
}

PackageSizeRadio.propTypes = {
  size_option: PropTypes.object,
  length: PropTypes.object,
  width: PropTypes.object,
  height: PropTypes.object,
}

export { PackageSizeRadio }
